/** Read body as text; supports test mocks that only implement `json()`. */
async function readResponseBody(response: Response): Promise<string> {
  if (typeof response.text === 'function') {
    return response.text();
  }
  if (typeof response.json === 'function') {
    const data = await response.json();
    return JSON.stringify(data);
  }
  return '';
}

/**
 * Parse a Funnelback fetch response as JSON. Validates HTTP status and non-empty body
 * before parsing so HTML error pages do not throw SyntaxError.
 */
export async function parseFunnelbackJsonResponse<T>(
  response: Response,
): Promise<T> {
  if (!response.ok) {
    throw new Error(`HTTP ${response.status}`);
  }

  const text = await readResponseBody(response);
  if (!text.trim()) {
    throw new Error('Empty response body');
  }

  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error('Invalid JSON response');
  }
}
